import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './a4b85e7870a80ecbd672d4d82bd7ec6b35ac25a47d5a2810396a7d84b68aff67.cfe-internal.js';

var _excluded = ["children", "className"];
var Table = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("table", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.table)
  }), children);
});

export { Table as default };
